export const environment = {
  production: true,
  name: 'production',
  API_HOST: 'https://videoteka-api.arkiva.gov.al',
  PAGE_SIZE: 100
};
